var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.56,
    height: 21.56,
    viewBox: "0 0 21.56 21.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7b29fb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1514.53 -474.97)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.013,33.2a3.813,3.813,0,1,0,3.813,3.813A3.821,3.821,0,0,0,37.013,33.2Zm0,5.7A1.884,1.884,0,1,1,38.9,37.013,1.879,1.879,0,0,1,37.013,38.9Z",
    transform: "translate(-1540.763 448.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.084,12.3H21a7.8,7.8,0,0,0-6.74-6.74V3.476a.976.976,0,1,0-1.952,0V5.564a7.8,7.8,0,0,0-6.74,6.74H3.476a.976.976,0,1,0,0,1.952H5.564A7.8,7.8,0,0,0,12.3,21v2.088a.976.976,0,0,0,1.952,0V21A7.8,7.8,0,0,0,21,14.256h2.088a.976.976,0,0,0,0-1.952Zm-9.8,6.808a5.833,5.833,0,1,1,5.833-5.833A5.831,5.831,0,0,1,13.28,19.113Z",
    transform: "translate(-1517.03 472.47)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current-location.b860b19b9b027d51c82c5663791d57fd.svg";
export { ForwardRef as ReactComponent };